<script setup lang="ts">
import { withDefaults, onMounted, ref, onUnmounted } from 'vue'

// @ts-ignore
import Gauge from '../assets/gauge.svg?skipsvgo'

const props = withDefaults(
  defineProps<{
    value?: number
  }>(),
  {
    value: 0
  }
)

const svg = ref()

onMounted(() => {
  const el = svg.value.$el as SVGElement
  const elements = el.querySelectorAll<SVGGElement>('g.needle')
  const idx = Math.min(Math.max(Math.round(props.value), 1), elements.length) - 1
  elements[idx].setAttribute('opacity', '1')
})

onUnmounted(() => {
  const el = svg.value.$el as SVGElement
  const elements = el.querySelectorAll<SVGGElement>('g.needle')
  elements.forEach((e) => e.setAttribute('opacity', '0'))
})
</script>

<template>
  <Gauge ref="svg" />
</template>

<style scoped>
</style>
